<template>
<div class="container">
    <div class="row">
        <div class="col-12 text-center mx-auto mb-4 mt-5">
            <h2 class=" hk-heading">Tailored Solutions For Every Experience </h2>
            <p class="sub-body mb-0">Boutique Hotels to Global Brands, Local to Independent Groups</p>
        </div>
        <div class="col-md-4 mt-4" v-for="(card, index) in cards" :key="index">
            <div class="card ">
                <!-- Added class for border box -->
                <div class="image-container">
                    <img :src="card.imgSrc" class="card-img-top" :alt=card.alt loading="lazy">
                    <h5 class="card-heading">{{ card.title }}</h5>
                </div>
                <div class="card-body border-box mb-4" >
                    <h4 class="hk-miniheading mb-4">{{card.heading}}</h4>
                    <p class="hk-subbody mb-3">{{card.discription}}</p>
                    <a :href="card.link" target="_blank" class="know-more">{{ $t('hk_all_btn.know_more') }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'TailoredSolutions',
    data() {
        return {
            cards: [{
                    imgSrc: require('@/assets/home/Solutions/property-type-global-brands.webp'),
                    title: this.$t("tailored_solutions.card_global_title"),
                    link: "/enterprise",
                    heading: this.$t("tailored_solutions.card_global_heading"),
                    discription: this.$t("tailored_solutions.card_global_discription"),
                    alt: " Global Brands | HotelKey"
                },
                {
                    imgSrc: require('@/assets/home/Solutions/property-type-regional-brands.webp'),
                    title: this.$t("tailored_solutions.card_regional_title"),
                    link: "/property-management-system",
                    heading: this.$t("tailored_solutions.card_regional_heading"),
                    discription: "Embrace enhanced efficiency and new business opportunities For hotel groups, enabling smarter operations across all hotel chains.",
                    alt: " Regional Brands | HotelKey"
                },
                {
                    imgSrc: require('@/assets/home/Solutions/property-type-residential.webp'),
                    title: this.$t("tailored_solutions.card_residential_title"),
                    link: "/tenant-key",
                    heading: this.$t("tailored_solutions.card_residential_heading"),
                    discription: "HotelKey’s Tenant Management System simplifies residential property operations, offering seamless leasing, payments, and maintenance management.",
                    alt: " Residential | HotelKey"

                },
                {
                    imgSrc: require('@/assets/home/Solutions/property-type-independent-hotels.webp'),
                    title: this.$t("tailored_solutions.card_independent_title"),
                    link: "/property-management-system",
                    heading: this.$t("tailored_solutions.card_independent_heading"),
                    discription: this.$t("tailored_solutions.card_independent_discription"),
                    alt: " Independent Hotels | HotelKey"

                },
                {
                    imgSrc: require('@/assets/home/Solutions/property-type-hostels.webp'),
                    title: this.$t("tailored_solutions.card_hostels_title"),
                    link: "/property-management-system",
                    heading: this.$t("tailored_solutions.card_hostels_heading"),
                    discription: "Experience guaranteed effortless hostel management, focusing on guest satisfaction while daily operations are handled seamlessly.",
                    alt: " Hostels | HotelKey"

                },
                {
                    imgSrc: require('@/assets/home/Solutions/property-type-food-beverage.webp'),
                    title: this.$t("tailored_solutions.card_food_beverage_title"),
                    link: "/retail-key",
                    heading: this.$t("tailored_solutions.card_food_beverage_heading"),
                    discription: "Discover a new dimension in POS and F&B management, enhancing efficiency and improving overall service quality in operations.",
                    alt: " Food & Beverage | HotelKey"

                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.card {
    margin-bottom: 20px;
    border: 0;
    /* Remove default border */
}

.border-box {
    border: 1px solid #D9D9D9;
    /* 1px border around the card */
    border-radius: 0px 0px 8px 8px;
    /* Optional: add rounded corners */
}

.image-container {
    position: relative;
}

.card {
    display: flex;
    flex-direction: column;
    height: 100%; /* Ensures all cards have the same height */
}

.card-body {
    flex-grow: 1; /* Ensures the body takes up available space */
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Distributes content evenly */
}

.card-img-top {
    width: 100%;
    height: 200px; /* Set a fixed height for uniform image size */
    object-fit: cover; /* Ensures images fit within the area */
}



.card-heading {
    position: absolute;
    color: #fff;
    bottom: 10px;
    /* Adjust as needed */
    left: 20px;
    /* Adjust as needed */
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    padding: 8px;
}



.hk-subbody {
    margin-bottom: auto;
    /* Push content to the top */
}

.know-more {
    align-self: flex-start;
    /* Align at the bottom of the card */
}

.outside-text {
    text-align: start;
    font-size: 20px;
    font-weight: 600;
    margin-top: 10px;
}

.outside-heading {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
}

.outside-subheading {
    font-size: 16px;
    font-weight: 400;
    font-family: Inter;
}

@media (max-width: 575.98px) {
    .headline {
        text-align: center !important;
        color: #192F4D;
        font-size: 2rem;
        font-weight: 700;
    }
}
</style>
